import { api } from '@/common/http/axios';
import type { BuildInfo } from '@/common/buildInfo';

// /api/build-info 无鉴权(见后端 auth.py AUTH_WHITELIST),失败给 unknown 兜底,
// 不影响左下角 badge 与关于页正常渲染。
export const fetchBackendBuildInfo = async (): Promise<BuildInfo | null> => {
  try {
    const res = await api.get('/build-info');
    return (res.data?.data as BuildInfo) ?? null;
  } catch {
    return null;
  }
};
